import { useEffect, useState } from 'react';
import { SecondaryButton } from '../../ui/Buttons';

interface ReadButtonProps {
  readPoints: () => void;
  lastWriteTime?: Date;
}

const ReadButton: React.FC<ReadButtonProps> = ({ readPoints, lastWriteTime }) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    let disabledTimeout: ReturnType<typeof setTimeout>;
    let countdownInterval: ReturnType<typeof setTimeout>;

    if (lastWriteTime) {
      setIsDisabled(new Date().getTime() - lastWriteTime.getTime() < 60 * 1000); // 1 minute
      setCountdown(60);

      disabledTimeout = setTimeout(() => {
        setIsDisabled(false);
        setCountdown(60);
      }, 60 * 1000);

      countdownInterval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }
    return () => {
      clearTimeout(disabledTimeout);
      clearInterval(countdownInterval);
    };
  }, [lastWriteTime]);

  return (
    <SecondaryButton onClick={readPoints} disabled={isDisabled}>
      <div>Read</div>
      {isDisabled && (
        <div className="countdown">
          {`${Math.floor(countdown / 60)}:${(countdown % 60).toString().padStart(2, '0')}`}
        </div>
      )}
    </SecondaryButton>
  );
};

export default ReadButton;
